import { Injectable, signal } from '@angular/core'

import { Event, IEvent } from './event'

@Injectable({ providedIn: 'root' })
export class ViewportService {
    readonly isNarrow = signal(false)
    readonly isTouch = signal(false)
    readonly isMobile = signal(false)
    readonly supportsDvh = signal(false)

    private _changed = new Event()
    get changed(): IEvent {
        return this._changed
    }

    private narrowMq: MediaQueryList | null = null
    private touchMq: MediaQueryList | null = null
    private compactMq: MediaQueryList | null = null

    constructor() {
        if (typeof window === 'undefined') return

        this.supportsDvh.set(typeof CSS !== 'undefined' && CSS.supports('height', '100dvh'))

        this.narrowMq = window.matchMedia('(max-width: 767.98px)')
        this.touchMq = window.matchMedia('(pointer: coarse)')
        this.compactMq = window.matchMedia('(max-width: 991.98px)')

        const onChange = () => this.refresh()
        this.narrowMq.addEventListener('change', onChange)
        this.touchMq.addEventListener('change', onChange)
        this.compactMq.addEventListener('change', onChange)
        window.visualViewport?.addEventListener('resize', onChange)

        this.refresh()
    }

    private refresh() {
        const isNarrow = this.narrowMq?.matches ?? false
        const isTouch = this.touchMq?.matches ?? false
        const isCompact = this.compactMq?.matches ?? false
        const isMobile = isNarrow || (isTouch && isCompact)

        const changed = this.isNarrow() !== isNarrow || this.isTouch() !== isTouch || this.isMobile() !== isMobile

        this.isNarrow.set(isNarrow)
        this.isTouch.set(isTouch)
        this.isMobile.set(isMobile)

        if (changed) {
            this._changed.raise()
        }
    }
}
